import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import classnames from 'classnames'
import styles from './index.module.less'

export interface ButtonProps {
  children?: any
  disabled?: boolean
  className?: string
  loading?: boolean
  type?: 'primary'
  shape?: 'default' | 'round'
  ghost?: boolean
  htmlType?: 'button' | 'submit'
  onClick?: Function
}
interface typeStyleProps {
  primary: string
}

interface shapeStyleProps {
  default: string
  round: string
}

const typeStyle: typeStyleProps = {
  primary: styles.primary,
}

const shapeStyle: shapeStyleProps = {
  default: styles.shapeDefault,
  round: styles.shapeRound,
}

export default function Index({
  children,
  disabled,
  className,
  loading,
  type,
  shape = 'default',
  ghost,
  htmlType = 'button',
  onClick,
}: ButtonProps) {
  return (
    <div className={classnames(styles.button, className)}>
      <button
        type={htmlType}
        className={classnames(
          type ? typeStyle[type] : '',
          shape ? shapeStyle[shape] : '',
          ghost ? styles.ghost : ''
        )}
        onClick={e => onClick && onClick(e)}>
        {loading && <LoadingOutlined className={styles.loadingIcon} />}
        {children}
      </button>
      {(disabled || loading) && <div className={styles.disabled}></div>}
    </div>
  )
}
